export const SET_LOADED = '@birdLoader/SET_LOADED';


export const setLoaded = async (dispatch) => { 
  dispatch({
    type: SET_LOADED
  });
}